import { SVGProps } from 'react';

const IcAdd = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M12 4.5C12.4142 4.5 12.75 4.83579 12.75 5.25V18.75C12.75 19.1642 12.4142 19.5 12 19.5C11.5858 19.5 11.25 19.1642 11.25 18.75V5.25C11.25 4.83579 11.5858 4.5 12 4.5Z'
        fill={props.fill || '#1D2129'}
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M4.5 12C4.5 11.5858 4.83579 11.25 5.25 11.25H18.75C19.1642 11.25 19.5 11.5858 19.5 12C19.5 12.4142 19.1642 12.75 18.75 12.75H5.25C4.83579 12.75 4.5 12.4142 4.5 12Z'
        fill={props.fill || '#1D2129'}
      />
      <path
        d='M12 4C12.6904 4 13.25 4.55964 13.25 5.25V10.75H18.75C19.4404 10.75 20 11.3096 20 12C20 12.6904 19.4404 13.25 18.75 13.25H13.25V18.75C13.25 19.4404 12.6904 20 12 20C11.3096 20 10.75 19.4404 10.75 18.75V13.25H5.25C4.55964 13.25 4 12.6904 4 12C4 11.3096 4.55964 10.75 5.25 10.75H10.75V5.25C10.75 4.55964 11.3096 4 12 4ZM11.75 13.25V18.75C11.75 18.8881 11.8619 19 12 19C12.1381 19 12.25 18.8881 12.25 18.75V13.25H11.75ZM13.25 12.25H18.75C18.8881 12.25 19 12.1381 19 12C19 11.8619 18.8881 11.75 18.75 11.75H13.25V12.25ZM11.75 12.25H12.25V11.75H11.75V12.25ZM5.25 11.75C5.11193 11.75 5 11.8619 5 12C5 12.1381 5.11193 12.25 5.25 12.25H10.75V11.75H5.25ZM12 5C11.8619 5 11.75 5.11193 11.75 5.25V10.75H12.25V5.25C12.25 5.11193 12.1381 5 12 5Z'
        fill={props.fill || '#1D2129'}
      />
    </svg>
  );
};

export default IcAdd;
